module.exports = __webpack_public_path__ + "static/media/18ECA52.caa26124.jpg";